/** MUI imports */
import { Box, Container, Divider, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import CompaniesTable from "../company/CompaniesTable";
import AddCompany from "./companydir/AddCompany";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import plansInfoNew from "../Js/plans";

import companyService from "../../services/company";
import casesServices from "../../services/case";
import usercompanyService from "../../services/user_company";
import authService from "../../services/auth";
import paymentMethodsService from "../../services/payment_methods";

import UpdateCompany from "./companydir/UpdateCompany";
import CompanyDet from "./companydir/CompanyDet";
import PaymentList from "./billing/PaymentList";
import InvoicesList from "./billing/InvoicesList";
import plansInfo from "../Js/plans";
import UpdateSubscription from "./companydir/UpdateSubscription";
import { initiateSocket, newUserResponse, subscribeToChat } from "../../services/Socket";
import ChatModal from "../ui/Chat";
import PlanSubs from "../subscription/plans/PlansMain";
import { getCompanyCredits, getCustomPlanId, updateCartPlan } from "../../utils/utils";
import AlertDialog from "../ui/AlertDialog";
import CustomForm from "../subscription/CustomForm";
import { addCredits, addIsGrouped, addSubscription } from "../../redux/userSlice";
import BaseButton from "../ui/BaseButton";
import ShoppingCartReg from "../subscription/shoppingCart/ShoppingCartReg";
import SubscriptionTab3 from "../subscription/SubscriptionTab3";
import AddCreditPacksDialog from "../credits/AddCreditPacksDialog";
import ChangePayDialog from "../subscription/shoppingCart/ChangePayDialog";
import AddPaymentDialog from "../payments/AddPaymentDialog";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        "aria-controls": `vertical-tabpanel-${index}`,
    };
}

const SubscriptionManag = (props) => {
    const { setIsLoading, setShow, setAlertType, setTexto } = props;
    const location = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [t] = useTranslation("global");
    const todos = useSelector((state) => state.value);
    const [value, setValue] = useState(0);
    const [openModalNewCompany, setOpenModalNewCompany] = useState(false);
    const [reload, setReload] = useState(false);
    const [addNew, setAddNew] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [smbInfo, setSmbInfo] = useState({});
    const [showCompanyDetails, setShowCompanyDetails] = useState(false);
    const [companyDetails, setCompanyDetails] = useState(null);
    const [companyDetailsGen, setCompanyDetailsGen] = useState({});
    const [valueCompany, setValueCompany] = useState(0);
    const [openCompanyDet, setOpenCompanyDet] = useState(false);
    const [allCompanies, setAllCompanies] = useState([]);
    const [payments, setPayments] = useState([]);
    const [franchiseDetails, setFranchiseDetails] = useState({});
    const [currentFreePlan, setCurrentFreePlan] = useState(0);
    const [maxFreePlan, setMaxFreePlan] = useState(0);
    const [franchiseSubsType, setFranchiseSubsType] = useState(null);
    const [room, setRoom] = useState(null);
    const [open, setOpen] = useState(false);
    const [chat, setChat] = useState([]);
    const [users, setUsers] = useState([]);
    const [caseInfo, setCaseInfo] = useState({});
    const [titleModal, setTitleModal] = useState("");
    const [openAlert, setOpenAlert] = useState(false);
    const [agreeBtnMsg, setAgreeBtnMsg] = useState(t("dialog.continue"));
    const [disagreeBtnMsg, setDisagreeBtnMsg] = useState(t("dialog.cancel"));
    const [bodyMess, setBodyMess] = useState("");
    const [currentPlan, setCurrentPlan] = useState({
        value: 0,
        custom: false,
    });
    const [paymentType, setPaymentType] = useState("monthly");
    const [currentLevel, setCurrentLevel] = useState("");
    const [priceMonthly, setPriceMonthly] = useState("");
    const [priceMonthlyOG, setPriceMonthlyOG] = useState("");
    const [questionCustom, setQuestionCustom] = useState({
        question1: "",
        question2: "",
        question3: "",
    });
    const [showCart, setShowCart] = useState(false);
    const [errorCustomPlan, setErrorCustomPlan] = useState(false);
    const [companyInfo, setCompanyInfo] = useState({
        id: null,
        companyType: 1, // 2: SMB | 1: Firma
        companyName: "",
        country: "",
        systems: [],
        ecActivity: "",
        system_subscription_name: "",
    });
    const [showSkeleton, setShowSkeleton] = useState(false);
    const [activePlan, setActivePlan] = useState(null); //Plan seleccionado
    const [showModalCredits, setShowModalCredits] = useState(false);
    const [showAddPay, setShowAddPay] = useState(false);
    const [showChangePay, setShowChangePay] = useState(false); // Modal para cambiar tarjeta
    const [defaultPayMethod, setDefaultPayMethod] = useState({});
    const [paymentMethods, setPaymentMethods] = useState([]);

    const handleCloseModal2 = (event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setShowAddPay(false);
            setShowChangePay(false);
            getPaymentMethods(true);
            setShowModalCredits(true);
        }
    };

    const handleCloseModal = (event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            setShowAddPay(false);
            setShowChangePay(true);
            getPaymentMethods(true);
        }
    };

    const handleCloseChangePay = () => {
        setShowChangePay(false);
        setShowModalCredits(true);
    };

    const handleAddPaymentM = () => {
        setShowAddPay(true);
        setShowChangePay(false);
    };

    const getPaymentMethods = async (reload) => {
        setIsLoading(true);

        const params = {
            franchise_id: todos.franchiseID,
            companyID: todos.companyID,
        };

        try {
            if (todos.companyID || todos.franchiseID) {
                const result = await paymentMethodsService.getPaymentMethods(params);
                const defaultPaymentMethod = result.find((card) => card.default_method);
                setDefaultPayMethod(defaultPaymentMethod);
                setPaymentMethods(result);
            }
        } catch (error) {
            console.log(error);
        }

        setIsLoading(false);
    };

    const handleSubmitCustomPlan = async () => {
        if (questionCustom.question1 === "" || questionCustom.question2 === "" || questionCustom.question3 === "") {
            setAlertType("error");
            setShow(true);
            setTexto(t("register.requiredData"));
            setErrorCustomPlan(true);
        } else {
            setErrorCustomPlan(false);
            handleCloseDialog();
            setIsLoading(true);

            const paramsC = {
                franchise_id: todos.franchiseID,
                planId: getCustomPlanId(),
                origin_form: "subscription",
                origin: 4,
                question1: questionCustom.question1,
                question2: questionCustom.question2,
                question3: questionCustom.question3,
                user_email: todos?.userInfo?.email,
            };

            // Se agrega free trial del plan 11
            await authService
                .addFreeTrialPlan(paramsC)
                .then(async () => {
                    await updateCompany();
                })
                .catch((error) => console.log(error.response));

            setIsLoading(false);
        }
    };

    const updateMicroPlan = async () => {
        handleCloseDialog();
        setIsLoading(true);
        await authService
            .addMicroPlan({
                franchise_id: todos.franchiseID,
                origin: "subscription",
                user_email: todos?.userInfo?.email,
            })
            .then(async () => {
                await updateCompany();
            })
            .catch((error) => console.log(error.response));
        setIsLoading(false);
    };

    const updateCompany = async () => {
        setIsLoading(true);
        await companyService
            .getFranchiseDetails(todos.franchiseID)
            .then(async (data) => {
                setShowCart(false);
                setActiveStep(0);
                setCompanyDetailsGen(data);
                dispatch(addIsGrouped(false));
                dispatch(
                    addSubscription({
                        value: data.id_status,
                        last_value: data.id_last_status,
                        plan: data.subscription.subscription_plan,
                    })
                );

                const credits = await getCompanyCredits(null, todos.franchiseID);
                dispatch(addCredits(credits));

                if (todos.selected === "ddlSalesInv") {
                    navigate(`/convert/invoices`);
                } else if (todos.selected === "ddlPurchaseInv") {
                    navigate(`/convert/bills`);
                } else {
                    navigate("/dashboard");
                }
            })
            .catch((err) => {
                console.log(err);
            });
        setIsLoading(false);
    };

    const handleCloseDialog = () => {
        setQuestionCustom({
            question1: "",
            question2: "",
            question3: "",
        });
        setOpenAlert(false);
    };

    const handleShowCart = async (e, planId = null) => {
        handleCloseDialog(false);
        const finalPlan = planId !== null ? planId : currentLevel;
        let activePlan = franchiseDetails?.subscription?.subscription_plan ?? null;
        let isCancelled =
            "subscription" in franchiseDetails &&
            franchiseDetails.subscription !== null &&
            "last_cancel" in franchiseDetails.subscription &&
            franchiseDetails.subscription.last_cancel !== null;
        if (
            activePlan &&
            activePlan >= 0 &&
            !(
                franchiseDetails.id_status === 1 ||
                (franchiseDetails.id_status === 4 && franchiseDetails.id_last_status === 1)
            ) &&
            !isCancelled
        ) {
            await updateCartPlan(
                activePlan > finalPlan ? 3 : 4,
                finalPlan,
                paymentType,
                franchiseDetails,
                setIsLoading,
                "month"
            );
        } else {
            await updateCartPlan(1, finalPlan, paymentType, franchiseDetails, setIsLoading, "month");
        }
        setShowCart(true);
    };

    const finalF = async () => {
        if (todos.franchiseID) {
            setIsLoading(true);
            await companyService
                .getFranchiseDetails(todos.franchiseID)
                .then(async (data) => {
                    // Se verifica si la empresa que se está updateando es la misma que se encuentra actualmente seleccionada, para actualizar navbars
                    if ("last_cancel" in data?.subscription) {
                        navigate("/management", {
                            state: {
                                tab: 0,
                                redirect_cancel: todos.franchiseID,
                            },
                        });
                    } else {
                        setShowCart(false);
                        setActiveStep(0);
                        setCompanyDetailsGen(data);
                        dispatch(addIsGrouped(false));
                        dispatch(
                            addSubscription({
                                value: data.id_status,
                                last_value: data.id_last_status,
                                plan: data.subscription.subscription_plan,
                            })
                        );

                        const credits = await getCompanyCredits(null, todos.franchiseID);
                        dispatch(addCredits(credits));
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsLoading(false);
        }
    };

    const handleChangeTab = async (event, newValue) => {
        let getFranInfo = false;

        if (newValue === 1 || newValue === 2 || newValue === 4) {
            getFranInfo = true;
        } else {
            if (newValue === 0) {
                setActiveStep(0);
            }
        }

        if (getFranInfo) {
            setIsLoading(true);
            await companyService
                .getFranchiseDetails(todos.franchiseID)
                .then((data) => {
                    setFranchiseDetails(data);
                    setActivePlan(data?.subscription?.subscription_plan);
                    setPaymentType(data?.last_invoice?.line_items[0]?.line_qty === 365 ? "annual" : "monthly");
                })
                .catch((error) => {
                    console.log(error);
                });
            setIsLoading(false);
        }

        setShowCompanyDetails(false);
        setOpenCompanyDet(false);
        setOpenModalNewCompany(false);
        setValue(newValue);
    };

    const handleChangeTabCompany = async (event, newValue) => {
        setValueCompany(newValue);
    };

    useEffect(() => {
        (async () => {
            const company_param = searchParams.get("company_id");
            const connected_param = searchParams.get("connected");
            const connect_param = searchParams.get("connect");
            const type_param = searchParams.get("redirectType");
            const alert_param = searchParams.get("alert");
            if (company_param && type_param === "1") {
                // Redirección de Xero o Quickbooks al conectarse
                if (connected_param && connected_param === "true" && connect_param) {
                    await companyService
                        .getCompanyDetails(company_param)
                        .then((data) => {
                            setSmbInfo(data);
                            setCompanyInfo({
                                id: data._id,
                                companyType: 1,
                                companyName: data.company_name,
                                country: data.country_name,
                                systems: data.file_formats,
                                ecActivity: data.business_activity,
                                system_subscription_name: data.system_subscription_name,
                            });

                            searchParams.delete("connected");
                            searchParams.delete("connect");
                            searchParams.delete("company_id");
                            searchParams.delete("redirectType");
                            searchParams.delete("alert");
                            setSearchParams(searchParams);

                            setOpenModalNewCompany(true);
                            setAddNew(false);
                            setActiveStep(2);
                            setAlertType("success");
                            setTexto(t("dialog.connectionEstablished"));
                            setShow(true);
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                } else {
                    // Botón de regresar
                    await companyService
                        .getCompanyDetails(company_param)
                        .then((data) => {
                            setSmbInfo(data);
                            setCompanyInfo({
                                id: data._id,
                                companyType: 1,
                                companyName: data.company_name,
                                country: data.country_name,
                                systems: data.file_formats,
                                ecActivity: data.business_activity,
                                system_subscription_name: data.system_subscription_name,
                            });

                            searchParams.delete("connected");
                            searchParams.delete("connect");
                            searchParams.delete("company_id");
                            searchParams.delete("redirectType");
                            searchParams.delete("alert");
                            setSearchParams(searchParams);
                            setOpenModalNewCompany(true);
                            setAddNew(false);

                            setActiveStep(2);
                            if (alert_param && alert_param === "1") {
                                setAlertType("error");
                                setTexto(t("dialog.alreadyConnected"));
                                setShow(true);
                            } else if (alert_param && alert_param === "2") {
                                setAlertType("error");
                                setTexto(t("dialog.connectionError1"));
                                setShow(true);
                            } else if (alert_param && alert_param === "3") {
                                setAlertType("error");
                                setTexto(t("dialog.connectionError2"));
                                setShow(true);
                            } else if (alert_param && alert_param === "4") {
                                setAlertType("error");
                                setTexto(t("dialog.connectionError3"));
                                setShow(true);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        })();
    }, [searchParams, t, setSearchParams, setActiveStep, setAlertType, setTexto, setShow]);

    useEffect(() => {
        (async () => {
            if (location.state?.tab === 0) {
                setValue(0);
                setShowCompanyDetails(false);
                setOpenCompanyDet(false);
                if (location.state?.createCompany === true) {
                    setOpenModalNewCompany(true);
                } else {
                    setOpenModalNewCompany(false);
                }
            }

            if (location.state?.tab === 1 || location.state?.tab === 2) {
                setValue(location.state?.tab);
                setIsLoading(true);
                await companyService
                    .getFranchiseDetails(todos.franchiseID)
                    .then((data) => {
                        setFranchiseDetails(data);
                        setActivePlan(data.subscription.subscription_plan);
                        setPaymentType(data?.last_invoice?.line_items[0]?.line_qty === 365 ? "annual" : "monthly");
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                setIsLoading(false);
            }

            const handleOpenCompany = async (companyID) => {
                setIsLoading(true);
                await usercompanyService
                    .getBusinessDirectoryDetails({ company_id: companyID })
                    .then((data) => {
                        setCompanyDetails(data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                setActiveStep(0);
                setOpenCompanyDet(true);
                setIsLoading(false);
            };

            if (location?.state !== null && "redirect_cancel" in location?.state) {
                await handleOpenCompany(location?.state?.redirect_cancel);
            }
        })();
    }, [location.state, setIsLoading, todos.franchiseID]);

    useEffect(() => {
        const franchiseInfo = todos.allComData.find((item) => item._id === todos.franchiseID);

        setCompanyDetailsGen(franchiseInfo);

        setCompanyInfo({ ...companyInfo, country: franchiseInfo.country_name });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [todos.allComData, todos.franchiseID]);

    const handleCloseModalCredits = () => {
        setShowModalCredits(false);
    };

    const connectSocketGen = async (case_id) => {
        setRoom(case_id);

        let params1 = {
            case_id: case_id,
        };

        await casesServices
            .getCaseInfo(params1)
            .then(async (data) => {
                setCaseInfo(data.caseInfo);

                initiateSocket(case_id, todos.userInfo, "general", "");
                subscribeToChat((err, data) => {
                    if (err) return;
                    setChat((oldChats) => [...oldChats, data]);
                });
                newUserResponse((err, data) => {
                    if (err) return;
                    setUsers(data);
                });
                setOpen(true);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleClickHelp = async () => {
        setIsLoading(true);

        let params = {
            company_id: todos.companyID,
            franchise_id: todos.franchiseID,
            user_email: todos.userInfo.email,
            type: "general",
        };

        await casesServices
            .createNewCase(params)
            .then(async (response) => {
                setCaseInfo(response);
                await connectSocketGen(response._id);
            })
            .catch((err) => {
                console.log(err);
            });
        setIsLoading(false);
    };

    return (
        <>
            {showCompanyDetails ? (
                <>
                    <Typography ml={1.8} mb={1} color="secondary" variant="h2" mt={4}>
                        {t("dialog.settings").replace(":", "")}{" "}
                    </Typography>
                    <Tabs
                        orientation={window.innerWidth < 600 ? "vertical" : "horizontal"}
                        value={valueCompany}
                        onChange={handleChangeTabCompany}
                        aria-label="Horizontal tabs"
                    >
                        <Tab label={t("management.companyData")} {...a11yProps(0)} sx={{ px: 4 }} />
                    </Tabs>
                    <Divider />
                    <Box sx={{ background: "#f7f8f9" }}>
                        <Container>
                            <TabPanel value={valueCompany} index={0}>
                                <UpdateCompany
                                    companyDetails={companyDetails}
                                    setIsLoading={setIsLoading}
                                    setTexto={setTexto}
                                    setShow={setShow}
                                    setAlertType={setAlertType}
                                    setCompanyDetails={setCompanyDetails}
                                />
                            </TabPanel>
                        </Container>
                    </Box>
                </>
            ) : (
                <>
                    <Box mt={6} mx={4} sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Typography variant="h2" color="secondary" gutterBottom>
                            {t("navBar.subscription")} {companyDetailsGen.franchise_name}
                        </Typography>
                        <Tabs
                            orientation={window.innerWidth < 600 ? "vertical" : "horizontal"}
                            value={value}
                            onChange={handleChangeTab}
                            aria-label="Horizontal tabs"
                        >
                            <Tab label={t("miscellaneous.companyDir")} {...a11yProps(0)} sx={{ px: 4 }} />
                            {companyDetailsGen.client_type === 1 && (
                                <Tab label={t("subscription.conversBalance")} {...a11yProps(1)} sx={{ px: 4 }} />
                            )}
                            {companyDetailsGen.client_type === 1 && (
                                <Tab label={t("plans.plans")} {...a11yProps(2)} sx={{ px: 4 }} />
                            )}
                            <Tab
                                label={t("payment.billing")}
                                {...a11yProps(companyDetailsGen.client_type !== 1 ? 1 : 3)}
                                sx={{ px: 4 }}
                            />
                            <Tab
                                label={t("navBar.config")}
                                {...a11yProps(companyDetailsGen.client_type !== 1 ? 2 : 4)}
                                sx={{ px: 4 }}
                            />
                        </Tabs>
                    </Box>
                    <Box mx={4}>
                        <TabPanel value={value} index={0}>
                            {!openModalNewCompany && !openCompanyDet && (
                                <CompaniesTable
                                    setOpenModalNewCompany={setOpenModalNewCompany}
                                    setAddNew={setAddNew}
                                    reload={reload}
                                    setCompanyDetails={setCompanyDetails}
                                    setOpenCompanyDet={setOpenCompanyDet}
                                    setIsLoading={setIsLoading}
                                    setAllCompanies={setAllCompanies}
                                    allCompanies={allCompanies}
                                    setCurrentFreePlan={setCurrentFreePlan}
                                    setMaxFreePlan={setMaxFreePlan}
                                    setFranchiseSubsType={setFranchiseSubsType}
                                    setCompanyInfo={setCompanyInfo}
                                    franchiseInfo={companyDetailsGen}
                                />
                            )}
                            {openCompanyDet && (
                                <CompanyDet
                                    setOpenCompanyDet={setOpenCompanyDet}
                                    setShowCompanyDetails={setShowCompanyDetails}
                                    companyDetails={companyDetails}
                                    allCompanies={allCompanies}
                                    activeStep={activeStep}
                                    setActiveStep={setActiveStep}
                                    setSmbInfo={setSmbInfo}
                                    smbInfo={smbInfo}
                                    setShow={setShow}
                                    setTexto={setTexto}
                                    setAlertType={setAlertType}
                                    setIsLoading={setIsLoading}
                                    setCompanyDetails={setCompanyDetails}
                                    maxFreePlan={maxFreePlan}
                                    currentFreePlan={currentFreePlan}
                                    handleClickHelp={handleClickHelp}
                                />
                            )}
                            {openModalNewCompany && (
                                <AddCompany
                                    onClose={() => setOpenModalNewCompany(false)}
                                    setReload={setReload}
                                    franchiseID={todos.franchiseID}
                                    setIsLoading={setIsLoading}
                                    setShow={setShow}
                                    setTexto={setTexto}
                                    setAlertType={setAlertType}
                                    addNew={addNew}
                                    franchiseInfo={companyDetailsGen}
                                    activeStep={activeStep}
                                    setActiveStep={setActiveStep}
                                    setSmbInfo={setSmbInfo}
                                    smbInfo={smbInfo}
                                    companyInfo={companyInfo}
                                    setCompanyInfo={setCompanyInfo}
                                    allCompanies={allCompanies}
                                    plansInfo={plansInfo}
                                    currentFreePlan={currentFreePlan}
                                    maxFreePlan={maxFreePlan}
                                    franchiseSubsType={franchiseSubsType}
                                    handleClickHelp={handleClickHelp}
                                />
                            )}
                        </TabPanel>
                        {companyDetailsGen.client_type === 1 && (
                            <TabPanel value={value} index={1}>
                                <SubscriptionTab3
                                    setIsLoading={setIsLoading}
                                    franchise_id={todos.franchiseID}
                                    company_id={todos.companyID}
                                    showSkeleton={showSkeleton}
                                    setShowSkeleton={setShowSkeleton}
                                    plansInfo={plansInfoNew}
                                    activePlan={activePlan}
                                    setShowModalCredits={setShowModalCredits}
                                    companyDetails={companyDetailsGen}
                                />
                            </TabPanel>
                        )}
                        {companyDetailsGen.client_type === 1 && (
                            <TabPanel value={value} index={2}>
                                {!showCart && (
                                    <PlanSubs
                                        setTitleModal={setTitleModal}
                                        setOpenAlert={setOpenAlert}
                                        setAgreeBtnMsg={setAgreeBtnMsg}
                                        setDisagreeBtnMsg={setDisagreeBtnMsg}
                                        setBodyMess={setBodyMess}
                                        setCurrentPlan={setCurrentPlan}
                                        paymentType={paymentType}
                                        setPaymentType={setPaymentType}
                                        setCurrentLevel={setCurrentLevel}
                                        setPriceMonthly={setPriceMonthly}
                                        setPriceMonthlyOG={setPriceMonthlyOG}
                                        currentLevel={currentLevel}
                                        priceMonthly={priceMonthly}
                                        origin="updateSubscription"
                                        currentPlan={currentPlan}
                                        activePlan={
                                            franchiseDetails.id_status === 3
                                                ? franchiseDetails?.subscription?.subscription_plan ?? null
                                                : null
                                        }
                                        handleShowCart={handleShowCart}
                                        companyDetails={franchiseDetails}
                                        setIsLoading={setIsLoading}
                                        setShowCart={setShowCart}
                                        setShow={setShow}
                                        setAlertType={setAlertType}
                                        setMessage={setTexto}
                                        isCancelled={
                                            "subscription" in franchiseDetails &&
                                            "last_cancel" in franchiseDetails.subscription
                                        }
                                    />
                                )}
                                {showCart && (
                                    <>
                                        <Stack direction="row" spacing={2} justifyContent="space-between" pt={4}>
                                            <BaseButton
                                                sizebutton="m"
                                                variantType="primaryOutlined"
                                                onClick={() => setShowCart(false)}
                                            >
                                                {t("miscellaneous.goBack")}
                                            </BaseButton>
                                            <BaseButton
                                                variantType="errorText"
                                                onClick={() => handleClickHelp("generalConv", "", "")}
                                            >
                                                {t("accounts.needHelp")}
                                            </BaseButton>
                                        </Stack>
                                        <ShoppingCartReg
                                            origin="updateSusbcription"
                                            currentPlan={currentPlan}
                                            setCurrentPlan={setCurrentPlan}
                                            paymentType={paymentType}
                                            setPaymentType={setPaymentType}
                                            currentLevel={currentLevel}
                                            priceMonthly={priceMonthly}
                                            priceMonthlyOG={priceMonthlyOG}
                                            setPriceMonthly={setPriceMonthly}
                                            setActiveStep={setActiveStep}
                                            allCompanies={allCompanies}
                                            smbInfo={franchiseDetails}
                                            finalF={finalF}
                                            setShowCart={setShowCart}
                                            activePlan={
                                                franchiseDetails.id_status === 3
                                                    ? franchiseDetails?.subscription?.subscription_plan ?? null
                                                    : null
                                            }
                                            setIsLoading={setIsLoading}
                                        />
                                    </>
                                )}
                            </TabPanel>
                        )}
                        <TabPanel value={value} index={companyDetailsGen.client_type !== 1 ? 1 : 3}>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={4}>
                                    <PaymentList
                                        setIsLoading={setIsLoading}
                                        setShow={setShow}
                                        setTexto={setTexto}
                                        setAlertType={setAlertType}
                                        payments={payments}
                                        setPayments={setPayments}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <InvoicesList payments={payments} setIsLoading={setIsLoading} />
                                </Grid>
                            </Grid>
                        </TabPanel>
                        <TabPanel value={value} index={companyDetailsGen.client_type !== 1 ? 2 : 4}>
                            <UpdateSubscription
                                franchiseDetails={franchiseDetails}
                                setIsLoading={setIsLoading}
                                setTexto={setTexto}
                                setShow={setShow}
                                setAlertType={setAlertType}
                            />
                        </TabPanel>
                    </Box>
                </>
            )}
            {showAddPay && (
                <AddPaymentDialog
                    open={showAddPay}
                    handleClose={handleCloseModal}
                    maxWidth="sm"
                    setShow={setShow}
                    setMessage={setTexto}
                    setAlertType={setAlertType}
                    setIsLoading={setIsLoading}
                    handleClose2={handleCloseModal2}
                    converter={true}
                />
            )}
            {showChangePay && (
                <ChangePayDialog
                    open={showChangePay}
                    handleClose={handleCloseChangePay}
                    payments={paymentMethods}
                    setIsLoading={setIsLoading}
                    reloadData={() => getPaymentMethods(true)}
                    defaultCard={defaultPayMethod}
                    handleAddPaymentM={handleAddPaymentM}
                />
            )}
            {open && (
                <ChatModal
                    room={room}
                    setRoom={setRoom}
                    open={open}
                    setOpen={setOpen}
                    setChat={setChat}
                    chat={chat}
                    users={users}
                    type={4}
                    franchiseName={
                        todos.allComData?.find(
                            (franchise) => franchise.franchise_name && franchise._id === todos.franchiseID
                        )?.franchise_name
                    }
                    chatDisabled={false}
                    setCaseInfo={setCaseInfo}
                    caseInfo={caseInfo}
                    createCase={true}
                />
            )}
            {showModalCredits && (
                <AddCreditPacksDialog
                    open={showModalCredits}
                    onClose={handleCloseModalCredits}
                    setShowAddPay={setShowAddPay}
                    setShowChangePay={setShowChangePay}
                    getPaymentMethods={() => getPaymentMethods(false)}
                    activePlan={activePlan}
                    paymentMethod={defaultPayMethod}
                    setIsLoading={setIsLoading}
                    currentPlan={currentPlan}
                    companyDetails={companyDetailsGen}
                    allCompanies={allCompanies}
                    paymentType={paymentType}
                />
            )}
            {openAlert && (
                <AlertDialog
                    open={openAlert}
                    onClose={handleCloseDialog}
                    agreeBtnLabel={agreeBtnMsg}
                    disagreeBtnLabel={disagreeBtnMsg}
                    type="info2"
                    title={titleModal}
                    message={
                        currentPlan.value === 3 && currentPlan.custom === true ? (
                            <CustomForm
                                setQuestionCustom={setQuestionCustom}
                                questionCustom={questionCustom}
                                errorCustomPlan={errorCustomPlan}
                            />
                        ) : (
                            bodyMess
                        )
                    }
                    agreeAction={
                        !currentPlan.custom
                            ? currentPlan.value === 0
                                ? franchiseDetails.subscription &&
                                  franchiseDetails?.subscription?.subscription_plan >= 0 // Downgrade
                                    ? handleShowCart
                                    : updateMicroPlan
                                : handleShowCart
                            : handleSubmitCustomPlan
                    }
                    maxWidth="sm"
                    origin="converter"
                    onlyAction={true}
                    oneAction={handleCloseDialog}
                />
            )}
        </>
    );
};

export default SubscriptionManag;
